import React from "react";
import { useTheme } from "./useTheme";
import { ThemeProviderProps } from "./Theme.types";

export default function ThemeProvider({ children, options, initial }: ThemeProviderProps) {
  const { setTheme, theme, setThemes } = useTheme();
  React.useEffect(() => {
    if (!!options && !!options.length) {
      setThemes(options);
    }
    if (!!initial && !theme) {
      setTheme(initial);
    }
  }, []);
  return <>{children}</>;
}
